import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(LanguageDetector) // deteksi bahasa dari browser/localStorage
    .use(initReactI18next)
    .init({
        resources: {
            id: { translation: require('./locales/id/translation.json') },
            en: { translation: require('./locales/en/translation.json') }
        },
        fallbackLng: 'id',
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'] // simpan pilihan di localStorage
        },
        interpolation: { escapeValue: false }
    });

export default i18n;